<template>
    <ul class="vuejs-countdown">
        <li v-if="days > 0">
            <p class="digit">{{ days | twoDigits }}</p>
            <p class="text">{{ days > 1 ? 'days' : 'day' }}</p>
        </li>
        <li v-if="hours > 0">
            <p class="digit">{{ hours | twoDigits }}</p>
            <p class="text">{{ hours > 1 ? 'hours' : 'hour' }}</p>
        </li>
        <li>
            <p class="digit">{{ minutes | twoDigits }}</p>
            <p class="text">min</p>
        </li>
        <li>
            <p class="digit">{{ seconds | twoDigits }}</p>
            <p class="text">Sec</p>
        </li>
    </ul>
</template>

<script>
let interval = null;
export default {
    name: 'countdown',
    props: {
        end: {
            type: [String, Date]
        },
        endYear: {
            type: [Number, String]
        },
        endMonth: {
            type: [Number, String]
        },
        endDay: {
            type: [Number, String]
        },
        endHour: {
            type: [Number, String],
            default: 0
        },
        endMinute: {
            type: [Number, String],
            default: 0
        },
        endSecond: {
            type: [Number, String],
            default: 0
        },
        endMilliseconds: {
            type: [Number, String],
            default: 0
        },
        isUTC: {
            type: Boolean,
            default: false
        },
        stop: {
            type: Boolean
        }
    },
    data() {
        return {
            now: Math.trunc((new Date()).getTime() / 1000),
            date: null,
            diff: 0
        }
    },
    created() {
        if (!this.end && !(this.endYear && this.endMonth && this.endDay)) {
            throw new Error("Missing props!");
        }
        else if (this.end && (this.endYear || this.endMonth || this.endDay)) {
            throw new Error("Conflicting props!");
        }

        let localDate;
        if (this.end) {
            if (typeof this.end == "string"){
                localDate = new Date(this.end.replace(/-/g, "/"));
            } else if (typeof this.end == "object") {
                localDate = this.end;
            }
        } else {
            localDate = new Date(this.endYear, this.endMonth-1, this.endDay, this.endHour, this.endMinute, this.endSecond, this.endMilliseconds);
        }

        if (this.isUTC) {
            let utcDate = Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), localDate.getHours(), localDate.getMinutes(), localDate.getSeconds(), localDate.getMilliseconds());
            localDate = new Date(utcDate);
        }

        this.date = Math.trunc(localDate / 1000);
        if (!this.date) {
            throw new Error("Invalid props value, correct the 'end'");
        }

        interval = setInterval(() => {
            this.now = Math.trunc((new Date()).getTime() / 1000);
        }, 1000);
    },
    computed: {
        seconds() {
            return Math.trunc(this.diff) % 60
        },
        minutes() {
            return Math.trunc(this.diff / 60) % 60
        },
        hours() {
            return Math.trunc(this.diff / 60 / 60) % 24
        },
        days() {
            return Math.trunc(this.diff / 60 / 60 / 24)
        }
    },
    watch: {
        now(value) {
            this.diff = this.date - this.now;
            if(this.diff <= 0 || this.stop){
                this.diff = 0;
                // Remove interval
                clearInterval(interval);
            }
        }
    },
    filters: {
        twoDigits(value) {
            if ( value.toString().length <= 1 ) {
                return '0'+value.toString()
            }
            return value.toString()
        }
    },
    destroyed() {
        clearInterval(interval);
    }
}
</script>
<style>
.vuejs-countdown {
  padding: 0;
  margin: 0;
}
.vuejs-countdown li {
  display: inline-block;
  margin: 0 8px;
  text-align: center;
  position: relative;
}
.vuejs-countdown li p {
    margin: 0;
}
.vuejs-countdown li:after {
  content: ":";
  position: absolute;
  top: 0;
  right: -13px;
  font-size: 32px;
}
.vuejs-countdown li:first-of-type {
  margin-left: 0;
}
.vuejs-countdown li:last-of-type {
  margin-right: 0;
}
.vuejs-countdown li:last-of-type:after {
  content: "";
}
.vuejs-countdown .digit {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 0;
}
.vuejs-countdown .text {
  text-transform: uppercase;
  margin-bottom: 0;
  font-size: 10px;
}
</style>